var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"login_type_2",attrs:{"href":"javascript:;"},on:{"click":_vm.loginWithFacebook}},[_c('img',{staticClass:"facebook",attrs:{"src":require("@/assets/img/facebook.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }